import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { maybeNavigateBack } from '@/common/utils/router';
import { NestedPage } from '@coverflex-tech/hypernova';
import { Href, useRouter } from 'expo-router';

interface Props {
  backRoute?: string;
  hideBack?: boolean;
  className?: string;
  children: ReactNode;
}

export const NestedRoute = ({
  backRoute,
  hideBack,
  className,
  children,
}: Props) => {
  const { t } = useTranslation();
  const router = useRouter();

  if (hideBack) {
    return <div className={className}>{children}</div>;
  }
  return (
    <NestedPage
      backLabel={t('general.back_label')}
      className={className}
      linkElement={
        backRoute ? <RouterLink href={backRoute as Href} /> : <button />
      }
      onBack={!backRoute ? () => maybeNavigateBack(router) : undefined}
    >
      {children}
    </NestedPage>
  );
};
